module.exports = __webpack_public_path__ + "img/hair_back_female_ponytail.af9dfaa0.png";